import { put, select, takeLatest } from 'redux-saga/effects';
import { getPreviousFiltersAction, setPreviousFiltersAction } from './actions';
import { PREVIOUS_FILTERS } from './constants';
import type { PreviousFiltersStore } from './types';
import {
  getAdultsCount,
  getDestinationId,
  getKidsAges,
} from '../../routes/SearchPage/selectors/searchParams';
import { setIsPreviousFiltersShown, setPreviousFiltersToSlice } from './slice';
import { searchTypeSelector } from '../view/selectors';

function* handleGetFilters() {
  try {
    const state = (yield JSON.parse(
      sessionStorage.getItem(PREVIOUS_FILTERS) || '{}',
    )) as PreviousFiltersStore;
    yield put(setPreviousFiltersToSlice(state));
    if (!Object.keys(state).length) {
      yield put(setIsPreviousFiltersShown(false));
      return;
    }
    const currentDestinationId = yield select(getDestinationId);
    const currentAdults = yield select(getAdultsCount);
    const currentKids = yield select(getKidsAges);
    const currentSearchType = yield select(searchTypeSelector);

    if (
      state.destinationId === currentDestinationId &&
      state.adults === currentAdults &&
      JSON.stringify(state.kids) === JSON.stringify(currentKids) &&
      state.searchType === currentSearchType
    ) {
      yield put(setPreviousFiltersAction(state.filters));
    } else yield put(setIsPreviousFiltersShown(true));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('e', e);
  }
}

export default function* previousFiltersSaga() {
  yield takeLatest(getPreviousFiltersAction.type, handleGetFilters);
}
